import { Nav } from "../components/Nav";
import { useTheme } from "../lib/theme";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Services } from "../components/Services";
import { Portfolio } from "../components/Portfolio";
import { BeforeAfter } from "../components/BeforeAfter";
import { Manifesto } from "../components/Manifesto";
import { About } from "../components/About";
import { DroneVideo } from "../components/DroneVideo";
import { Tour3D } from "../components/Tour3D";
import { Testimonials } from "../components/Testimonials";
import { Pricing } from "../components/Pricing";
import { Faq } from "../components/Faq";
import { Booking } from "../components/Booking";
import { CtaBanner } from "../components/CtaBanner";
import { Footer } from "../components/Footer";

export default function Home() {
  const theme = useTheme();
  return (
    <div className={`bg-[#0D0F12]${theme === "light" ? " light" : ""}`} data-testid="home-page">
      <Nav />
      <Hero />
      <Marquee />
      <Services />
      <Portfolio />
      <BeforeAfter />
      <Manifesto />
      <About />
      <DroneVideo />
      <Tour3D />
      <Pricing />
      <Booking />
      <CtaBanner />
      <Testimonials />
      <Faq />
      <Footer />
    </div>
  );
}
